// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { CheckCircle, XCircle, AlertTriangle, Info, X } from "lucide-react";

const InlineNotification = ({ notification, onClose }) => {
  if (!notification) return null;

  const { message, type = "success" } = notification;

  const getNotificationStyles = () => {
    switch (type) {
      case "error":
        return {
          container: "bg-red-50 text-red-800 border border-red-200",
          icon: <XCircle className="h-5 w-5" />,
        };
      case "warning":
        return {
          container: "bg-yellow-50 text-yellow-800 border border-yellow-200",
          icon: <AlertTriangle className="h-5 w-5" />,
        };
      case "info":
        return {
          container: "bg-blue-50 text-blue-800 border border-blue-200",
          icon: <Info className="h-5 w-5" />,
        };
      case "success":
      default:
        return {
          container: "bg-green-50 text-green-800 border border-green-200",
          icon: <CheckCircle className="h-5 w-5" />,
        };
    }
  };

  const styles = getNotificationStyles();

  return (
    <div
      className={`mb-6 p-4 rounded-lg flex items-center gap-3 ${styles.container}`}
    >
      {styles.icon}
      <span className="flex-1">{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          className="text-current hover:opacity-70 transition-opacity"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default InlineNotification;
